import { POST } from '@wellsfargo/ecpfs-authority'

export const CREATE_ACCOUNT = 'register/createAccount.json'

export function createAccount(deliveryMode) {
	return POST(CREATE_ACCOUNT, deliveryMode)
}
